import { z } from "zod";

export const WalletsTracerKeyInfoResponse = z
  .object({
    data: z.any().optional(),
    meta: z.any().optional(),
  })
  .passthrough();

export const WalletsSignMessageResponse = z
  .object({
    data: z.any().optional(),
    meta: z.any().optional(),
  })
  .passthrough();

export const WalletsTransferGGoldResponse = z
  .object({
    data: z.any().optional(),
    meta: z.any().optional(),
  })
  .passthrough();

export const WalletsConvertResponse = z
  .object({
    data: z.any().optional(),
    meta: z.any().optional(),
  })
  .passthrough();

export const WalletsAddProfitToWithdrawableResponse = z
  .object({
    data: z.any().optional(),
    meta: z.any().optional(),
  })
  .passthrough();

export default WalletsConvertResponse;
